import React, { useEffect, useRef } from 'react'
import gsap from 'gsap';

const RoundText = ({ color }) => {

    const text = useRef(null)
    const circle = useRef(null)

    useEffect(() => {
        gsap.set("svg", { autoAlpha: 1 });

        gsap.timeline({ defaults: { ease: "none", duration: 4 } })
            .from(text.current, { attr: { startOffset: "100%" } })
            .to(text.current, 3, { rotation: "360", ease: 'Linear.easeNone', repeat: -1 })
            .to(circle.current, { rotation: '360', transformOrigin: "center center", repeat: -1 })
    }, [])


    return (
        <svg  viewBox="0 0 180 180">
            <path ref={circle} id="circle" d="
                M 100, 100
                m -75, 0
                a 75,75 0 1,0 150,0
                a 75,75 0 1,0 -150,0
                " style={{ fill: 'transparent' }}>
            </path>
            <text width="160">
                <textPath ref={text} startOffset="1" alignmentBaseline="top" style={{ fontFamily: 'sans-serif', fontSize: '20.5px', fontWeight: '600', fill: color }} xlinkHref="#circle">
                    Discover &bull; Design &bull; Develop &bull; Deliver &bull; Repeat &bull;
                </textPath>
            </text>
        </svg>
    )
}

export default RoundText